import { useEffect, useState } from "react";

import AppContainer from "../../../commons/containers/AppContainer";
import AppLoading from "../../../commons/AppLoading";
import CompanyAPI from "../../company/CompanyAPI";
import HPStep1 from "./steps/HPStep1";
import HPStep2 from "./steps/HPStep2";
import HPStep3 from "./steps/HPStep3";
import HPStep4 from "./steps/HPStep4";
import HPStepResume5 from "./steps/HPStepResume5";
import HallAppToast from "../../../commons/HallAppToast";
import HallPointsAPI from "../HallPointsAPI";
import { Modal } from "react-bootstrap";

const companyAPI = new CompanyAPI();
const hallPointAPI = new HallPointsAPI();

/* eslint-disable react-hooks/exhaustive-deps */
function ModalHallPointsConfigurations({ closeShow, show, findAllConfigs, selectedConfig }) {

    const [step, setStep] = useState(1);

    const [step1Data, setStep1Data] = useState([]);
    const [ruleType, setRuleType] = useState(null);
    const [pointsConfig, sePointsConfig] = useState({});
    const [, setPointsInfo] = useState({});
    const [configToEdit, setConfigToEdit] = useState({});

    const [data, setData] = useState({});

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        if (selectedConfig != null && Object.keys(selectedConfig).length > 0) {
            findById()
        } else {
            setIsLoading(false)
        }
    }, []);

    async function findById() {
        try {
            const response = await hallPointAPI.findById(selectedConfig.id);
            setConfigToEdit(response.data)
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoading(false)
        }
    }

    const next = (value) => {
        if (step === 1) {
            setStep1Data(value)
        } else if (step === 2) {
            setRuleType(value)
        } else if (step === 3) {
            sePointsConfig(value)
        } else if (step === 4) {
            setPointsInfo(value)
            const resume = {
                companyId: companyAPI.getCompanyManagment().id,
                name: step1Data.name,
                services: step1Data.services,
                ruleType: ruleType,
                pointsConfig: pointsConfig,
                pointsInfo: value
            }
            setData(resume)
        }
        setStep(step + 1)
    }

    const back = () => {
        setStep(step - 1)
    }

    return (
        <>
            <Modal show={show} fullscreen={true} onHide={() => closeShow()}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ textAlign: 'center', fontSize: '15px' }}>
                        HALLPOINTS - Configuração
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <AppContainer>
                        {isLoading ? <AppLoading /> :
                            <>
                                {step === 1 && <HPStep1 nextStep={next} configToEdit={configToEdit} />}
                                {step === 2 && <HPStep2 nextStep={next} toBack={back} configToEdit={configToEdit} />}
                                {step === 3 && <HPStep3 nextStep={next} toBack={back} ruleType={ruleType} configToEdit={configToEdit} />}
                                {step === 4 && <HPStep4 nextStep={next} toBack={back} ruleType={ruleType} configToEdit={configToEdit} />}
                                {step === 5 && <HPStepResume5 findAllConfigs={findAllConfigs} toBack={back} data={data} closeShow={closeShow} configToEdit={configToEdit} />}
                            </>
                        }
                    </AppContainer>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ModalHallPointsConfigurations;